import { Navigate, Route, Routes } from 'react-router-dom'
import TruckHistory from './TruckHistory'

export default function TruckHistoryRoutes() {
    return (
        <Routes>
            <Route index element={<TruckHistory />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
